/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EngineResponseDto } from './EngineResponseDto';

export type UserDetailResponseDto = {
    /**
     * ID пользователя
     */
    id: number;
    /**
     * ID пользователя в Keycloak
     */
    keycloakUserId: string;
    /**
     * Дата создания
     */
    createdAt: string;
    /**
     * Дата обновления
     */
    updatedAt: string;
    /**
     * Фамилия
     */
    lastname: string;
    /**
     * Имя
     */
    firstname: string;
    /**
     * Отчество
     */
    middleName?: string;
    /**
     * Компания
     */
    company: string;
    /**
     * ИНН компании
     */
    innCompany?: string;
    /**
     * Email
     */
    email: string;
    /**
     * Статус пользователя
     */
    status: UserDetailResponseDto.status;
    /**
     * Комментарий
     */
    comment?: string;
    /**
     * Мобильный телефон
     */
    mobilePhone?: string;
    /**
     * Список двигателей пользователя
     */
    engines?: Array<EngineResponseDto>;
};

export namespace UserDetailResponseDto {

    /**
     * Статус пользователя
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        SUSPENDED = 'SUSPENDED',
        PENDING = 'PENDING',
    }


}

